<script>
    import BaseComponent from "Components/equipments/Index";
    export default {
        extends: BaseComponent,
        props: {
            customerId: {
                type: [Number, String],
                required: true
            }
        },
        methods: {
            async initialize () {
                var query = this.$db.Equipment
                    .append('customer_name')
                    .where('customer_id', this.customerId)
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            }
        }
    };
</script>
